module.exports = __webpack_public_path__ + "img/20200507_134547.5c170806.jpg";